import { dummyBankFeedSmartReconStatement } from '../../../containers/AppPage/Bank/Accounts/Reconciliations/Options/BankFeedReconOption/dummy';
import { dummyBankFeedsV2 } from '../../../containers/AppPage/Bank/BankFeedConnect/dummy/dummyBankFeeds';
import { dummyBankFeedTransactions } from '../../../containers/AppPage/Bank/BankFeedTransactions/dummyBankFeedTransactions';
import { BankAccountsWithBankFeeds } from '../../BankAccount/dummy/BankAccountsWithBankFeed';
import { BANK_FEED_MBB_ACCOUNT } from '../../BankAccount/dummy/BankFeedMbbAccount';
import BankFeedActions from '../actions';
import { DUMMY_MAYBANK_REDIRECT_URI } from './static';

// Dummy Response - some endpoints don't have response
export const BankFeedDummyDatas = {
    BANK_ACCOUNTS_WITH_BANK_FEED: BankAccountsWithBankFeeds,
    BANK_ACCOUNT_WITH_CONNECTION: BANK_FEED_MBB_ACCOUNT,

    BANK_FEED_PENDING_CHECKER: null,

    [BankFeedActions.BANK_FEED_READ_ALL_REQUEST]: dummyBankFeedsV2,

    [BankFeedActions.BANK_FEED_CONNECT_REQUEST]: DUMMY_MAYBANK_REDIRECT_URI,
    [BankFeedActions.BANK_FEED_DISCONNECT_REQUEST]: null,
    [BankFeedActions.BANK_FEED_SYNC_REQUEST]: null,

    [BankFeedActions.BANK_FEED_TRANSACTION_READ_ALL_REQUEST]: dummyBankFeedTransactions,
    [BankFeedActions.BANK_FEED_TRANSACTION_DELETE_REQUEST]: null,
    [BankFeedActions.BANK_FEED_TRANSACTION_BULK_DELETE_REQUEST]: null,

    [BankFeedActions.BANK_FEED_SMART_RECON_REQUEST]: dummyBankFeedSmartReconStatement,

};
